export default __webpack_public_path__ + "static/media/explosion.615cfd43.mp3";